if (!customElements.get('product-sizes-swapper')) {
  customElements.define(
    'product-sizes-swapper',
    class ProductSizesSwapper extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.currentHandle = this.dataset.currentHandle;
      }

      connectedCallback() {
        this.bindEvents();
      }

      bindEvents() {
        this.querySelectorAll('.product-sizes-swapper__option').forEach((btn) => {
          btn.addEventListener('click', this.handleSwap.bind(this));
        });
      }

      async handleSwap(event) {
        const button = event.currentTarget;
        const handle = button.dataset.productHandle;

        if (button.classList.contains('product-sizes-swapper__option--active')) return;

        this.classList.add('swapper-loading');
        button.classList.add('product-sizes-swapper__option--swapping');

        try {
          const response = await fetch(`/products/${handle}?sections=${this.sectionId}`);
          if (!response.ok) throw new Error(`HTTP error ${response.status}`);

          const data = await response.json();
          const newHtml = data[this.sectionId];

          if (newHtml) {
            const sectionContainer = document.getElementById(`shopify-section-${this.sectionId}`);
            const oldModal = document.querySelector('product-modal');
            if (oldModal) {
              oldModal.remove();
            }
            if (sectionContainer) {
              sectionContainer.innerHTML = newHtml;

              sectionContainer.querySelectorAll('script').forEach((oldScript) => {
                const newScript = document.createElement('script');
                Array.from(oldScript.attributes).forEach((attr) => {
                  newScript.setAttribute(attr.name, attr.value);
                });
                if (!oldScript.src) {
                  newScript.textContent = oldScript.textContent;
                }
                oldScript.parentNode.replaceChild(newScript, oldScript);
              });

              window.history.replaceState({}, '', `/products/${handle}`);

              if (window.Shopify && window.Shopify.PaymentButton) {
                window.Shopify.PaymentButton.init();
              }

              if (window.ProductModel) {
                window.ProductModel.loadShopifyXR();
              }

              sectionContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        } catch (error) {
          console.error('[ProductSizesSwapper] Error swapping product:', error);
          this.classList.remove('swapper-loading');
          button.classList.remove('product-sizes-swapper__option--swapping');
        }
      }
    }
  );
}
